import React from 'react'
import PropTypes from 'prop-types'
import { Drawer, Spin, Button } from 'antd'

const noop = () => {}

class WrappedModal extends React.Component {
  constructor (props) {
    super(props)
    this.form = React.createRef() // 创建Form表单
    this.state = {
      open: false,
      confirmLoading: false
    }
  }

  static propTypes = {
    baseComponent: PropTypes.element.isRequired,
    baseProps: PropTypes.object,
    style: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mask: PropTypes.bool,
    maskClosable: PropTypes.bool,
    destroyOnClose: PropTypes.bool,
    closable: PropTypes.bool,
    footer: PropTypes.node,
    okText: PropTypes.string,
    okType: PropTypes.string,
    cancelText: PropTypes.string,
    onOk: PropTypes.func,
    onCancel: PropTypes.func
  }

  static defaultProps = {
    style: {},
    maskClosable: false,
    destroyOnClose: true,
    placement: 'right',
    okText: '确定',
    cancelText: '取消',
    onOk: noop,
    onCancel: noop
  }

  componentWillUnmount () {
    this.cancelled = true
  }

  showModal = e => {
    e.stopPropagation()
    this.setState({ open: true })
  }

  hideModal = () => {
    const { onClose } = this.props
    if (onClose) {
      onClose()
    }
    this.setState({ open: false })
  }

  handleOk = async () => {
    try {
      this.setState({ confirmLoading: true })
      await Promise.resolve(this.props.onOk(this.form))
      if (!this.cancelled) {
        this.setState({ confirmLoading: false, open: false })
      }
    } catch (error) {
      this.setState({ confirmLoading: false })
      console.log('wrapModal handleOk error: ', error)
    }
  }

  render () {
    const { open, confirmLoading } = this.state
    const {
      footer,
      okText,
      cancelText,
      children,
      baseProps,
      baseComponent,
      styles: userStyles,
      ...modalProps
    } = this.props
    const defaultFooter = (
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          background: '#fff',
          borderRadius: '0 0 4px 4px',
          zIndex: 999
        }}
      >
        <Button
          style={{
            marginRight: 8
          }}
          disabled={confirmLoading}
          onClick={this.hideModal}
        >
          {cancelText}
        </Button>
        <Button
          type="primary"
          loading={confirmLoading}
          disabled={confirmLoading}
          onClick={this.handleOk}
        >
          {okText}
        </Button>
      </div>
    )

    const modal = (
      <Drawer
        style={{
          height: 'calc(100%)',
          paddingBottom: 53
        }}
        styles={{
          ...userStyles,
          body: {
            ...userStyles?.body,
            // 避免宽表格把整抽屉撑出横向滚动；横向由内部 Table.scroll 等处理
            overflowY: userStyles?.body?.overflowY ?? 'auto',
            overflowX: 'hidden'
          }
        }}
        {...modalProps}
        open={open}
        onClose={this.hideModal}
      >
        <Spin spinning={confirmLoading}>
          {React.cloneElement(baseComponent, { ...baseProps, ...baseComponent.props, form: this.form })}
        </Spin>
        {footer || footer === null ? footer : defaultFooter}
      </Drawer>
    )

    // 合并 children 的样式，添加 cursor: pointer
    const childrenStyle = children?.props?.style || {};
    const mergedStyle = {
      ...childrenStyle,
      cursor: 'pointer',
    };

    return (
      <React.Fragment>
        <span onClick={(e) => e.stopPropagation()}>
          {React.cloneElement(children, {
            key: 'tigger',
            onClick: this.showModal,
            style: mergedStyle,
          })}
          {modal}
        </span>
      </React.Fragment>
    )
  }
}

export default WrappedModal
